import { render, staticRenderFns } from "./MyPageSubscriptionSeller.vue?vue&type=template&id=08480ff5&scoped=true&"
import script from "./MyPageSubscriptionSeller.vue?vue&type=script&lang=js&"
export * from "./MyPageSubscriptionSeller.vue?vue&type=script&lang=js&"
import style0 from "./MyPageSubscriptionSeller.vue?vue&type=style&index=0&id=08480ff5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08480ff5",
  null
  
)

export default component.exports